// Exec
import mia from "../images/about/spring2025/mia.thumb.jpg"; // President
import jenny from "../images/about/spring2026/jenny.thumb.jpg";
// import anupriya from "../images/about/spring2026/anupriyaalt.thumb.jpg"; // VPP — using placeholder for now
import ashwika from "../images/about/spring2026/ashwika.thumb.jpg";
import yashom from "../images/about/spring2025/yashom.thumb.jpg";
import jonathan from "../images/about/spring2026/jonathan.thumb.jpg"; // VPPD
import benh from "../images/about/spring2026/benh.thumb.jpg";
import diego from "../images/about/spring2026/diego.thumb.jpg"; // VP Finance
// import sophie from "../images/about/spring2026/sophie.thumb.jpg"; // no longer VP Finance
import felicia from "../images/about/spring2026/felicia.thumb.jpg";
import ashleyl from "../images/about/spring2026/ashleyl.thumb.jpg"; // VP Marketing
// import ava from "../images/about/spring2025/ava.thumb.jpg"; // no longer VP Marketing
import ashleyi from "../images/about/spring2026/ashleyi.thumb.jpg"; // VP Design
// import devah from "../images/about/spring2026/devah.thumb.jpg"; // no longer VP Tech
import peter from "../images/about/spring2026/peter.thumb.jpg";
import helena from "../images/about/spring2026/helena.thumb.jpg"; // VP Internals
import karthik from "../images/about/spring2026/karthik.thumb.jpg";
import ryan from "../images/about/spring2026/ryan.thumb.jpg";
// import benr from "../images/about/spring2026/benr.thumb.jpg"; // no longer a project manager
// import yon from "../images/about/spring2026/yon.thumb.jpg"; // no longer VP Client
// import anupriya from "../images/about/spring2026/anupriya.thumb.jpg";
// import jonathan from "../images/about/spring2026/jonathan.thumb.jpg";
// import ashleyi from "../images/about/spring2026/ashleyi.thumb.jpg"; // VP Community
import placeholder from "../images/about/person-placeholder.svg"; // TODO: replace with real photos once available

// Project Managers (Fall 2026) — project assignments TBD, using placeholder photos until real ones are provided
// import karthikeya from "../images/about/spring2026/karthikeya.thumb.jpg"; // CoPatible
// import zehra from "../images/about/spring2026/zehra.thumb.jpg"; // no longer a project manager
// import charmi from "../images/about/spring2026/charmi.thumb.jpg"; // no longer a project manager
import harshini from "../images/about/spring2026/harshini.thumb.jpg";
import sainik from "../images/about/spring2026/sainik.thumb.jpg";
import justin from "../images/about/spring2026/justin.thumb.jpg";
// import anupriya from "../images/about/spring2026/anupriya.thumb.jpg"; // Atlas
// import andre from "../images/about/fall2025/andre.thumb.jpg"; // no longer a project manager
// import erin from "../images/about/spring2026/erin.thumb.jpg"; // no longer a project manager
// import andrew from "../images/about/spring2026/andrew.thumb.jpg"; // not a project manager
import ganesh from "../images/about/spring2026/ganesh.thumb.jpg";
// import jaydens from "../images/about/spring2026/jaydens.thumb.jpg"; // no longer a project manager
import arnav from "../images/about/spring2026/arnav.thumb.jpg";
import chris from "../images/about/spring2026/chris.thumb.jpg";
// import jaydenl from "../images/about/spring2026/jaydenl.thumb.jpg"; // no longer a project manager
import leo from "../images/about/spring2026/leo.thumb.jpg";
// import jonathan from "../images/about/spring2026/jonathan.thumb.jpg"; // IBM
// import diego from "../images/about/spring2026/diego.thumb.jpg";
// import benh from "../images/about/spring2026/benh.thumb.jpg";
// import jenny from "../images/about/spring2026/jenny.thumb.jpg"; // BM
// import mia from "../images/about/spring2026/mia.thumb.jpg";
import annie from "../images/about/spring2026/annie.thumb.jpg";
// import parsa from "../images/about/spring2026/parsa.thumb.jpg"; // no longer a project manager
// import jessica from "../images/about/spring2026/jessica.thumb.jpg"; // no longer a project manager
import megan from "../images/about/spring2026/megan.thumb.jpg";
import nishaad from "../images/about/spring2026/nishaad.thumb.jpg";
// import emily from "../images/about/spring2026/emily.thumb.jpg"; // no longer a project manager
// import david from "../images/about/spring2026/david.thumb.jpg"; // no longer a project manager
// import yashom from "../images/about/spring2026/yashom.thumb.jpg"; // ChessBlitz
// import peter from "../images/about/spring2026/peter.thumb.jpg";
// import noor from "../images/about/spring2026/noor.thumb.jpg"; // no longer a project manager
// import surabhi from "../images/about/spring2026/surabhi.thumb.jpg"; // no longer a project manager
import chad from "../images/about/spring2026/chad.thumb.jpg";
// import ryan from "../images/about/spring2026/ryan.thumb.jpg";
// import felicia from "../images/about/spring2026/felicia.thumb.jpg"; // Syncrate
// import helena from "../images/about/spring2026/helena.thumb.jpg";

// Alumni
import ethan from "../images/about/fall2023/ethan.thumb.jpg";
import colin from "../images/about/spring2023/colin.thumb.jpg";
import nick from "../images/about/spring2023/nick.thumb.jpg";
import uyen from "../images/about/fall2023/uyen.thumb.jpg";
import joel from "../images/about/fall2023/joel.thumb.jpg";
import nhu from "../images/about/fall2023/nhu.thumb.jpg";
import jess from "../images/about/spring2024/jess.thumb.jpg";
import christopher from "../images/about/spring2024/chris.thumb.jpg";
import kitty from "../images/about/spring2024/kitty.thumb.jpg";
import rohan from "../images/about/spring2024/rohan.thumb.jpg";
import zee from "../images/about/fall2023/zee.thumb.jpg";

export const board = [
    {
        name: "Mia Salinas",
        title: "Co-President",
        image: mia,
    },
    {
        name: "Jenny Liang",
        title: "Co-President",
        image: jenny,
    },
    {
        name: "Anupriya Islam",
        title: "VP of Projects",
        image: placeholder,
    },
    {
        name: "Chad Park",
        title: "VP of Projects",
        image: chad,
    },
    {
        name: "Christopher Chang",
        title: "VP of Projects",
        image: chris,
    },
    {
        name: "Ganesh Karayi",
        title: "VP of Projects",
        image: ganesh,
    },
    {
        name: "Ashley Li",
        title: "VP of Marketing",
        image: ashleyl,
    },
    {
        name: "Annie Lin",
        title: "VP of Marketing",
        image: annie,
    },
    {
        name: "Ashley Iattoni",
        title: "VP of Design",
        image: ashleyi,
    },
    {
        name: "Helena Zhang",
        title: "VP of Internals",
        image: helena,
    },
    {
        name: "Ryan Lin",
        title: "VP of Internals",
        image: ryan,
    },
    {
        name: "Jonathan Tran",
        title: "VP of Professional Development",
        image: jonathan,
    },
    {
        name: "Megan Nguyen",
        title: "VP of Professional Development",
        image: megan,
    },
    {
        name: "Arnav Mahadev",
        title: "VP of Professional Development",
        image: arnav,
    },
    {
        name: "Ashwika Gampa",
        title: "VP of Client",
        image: ashwika,
    },
    {
        name: "Benjamin Huang",
        title: "VP of Client",
        image: benh,
    },
    {
        name: "Nicole Ta",
        title: "VP of Externals",
        image: placeholder,
    },
    {
        name: "Sriya Bandarupalli",
        title: "VP of Externals",
        image: placeholder,
    },
    {
        name: "Diego Llamas",
        title: "VP of Finance",
        image: diego,
    },
    {
        name: "Felicia Ye",
        title: "VP of Finance",
        image: felicia,
    },
    {
        name: "Peter Lourenco",
        title: "VP of Tech",
        image: peter,
    },
    {
        name: "Yashom Kapoor",
        title: "VP of Tech",
        image: yashom,
    },
];

export const projectLeads = [
    {
        name: "James Apuyan",
        image: placeholder,
        project: "CalConnect",
    },
    {
        name: "Turner Osswald",
        image: placeholder,
        project: "Get to the Surface",
    },
    {
        name: "Jamil Shirinov",
        image: placeholder,
        project: "CalConnect",
    },
    {
        name: "Leo Li",
        image: placeholder,
        project: "CalConnect",
    },
    {
        name: "Janice Lin",
        image: placeholder,
        project: "TrailFinder",
    },
    {
        name: "Melody Shane",
        image: placeholder,
        project: "TrailFinder",
    },
    {
        name: "Miles Petrick",
        image: placeholder,
        project: "TrailFinder",
    },
    {
        name: "Johanna Flores",
        image: placeholder,
        project: "Trinket",
    },
    {
        name: "Keira Tan",
        image: placeholder,
        project: "Trinket",
    },
    {
        name: "Joseph Ong",
        image: placeholder,
        project: "Property Damage",
    },
    {
        name: "Zander Rosenzweig",
        image: placeholder,
        project: "Property Damage",
    },
    {
        name: "Harshini Pulivarthi",
        image: harshini,
        project: "CurbIQ",
    },
    {
        name: "Sneha Atmakur",
        image: placeholder,
        project: "CurbIQ",
    },
    {
        name: "Ayah Elzein",
        image: placeholder,
        project: "NothingButNet",
    },
    {
        name: "Navya Lella",
        image: placeholder,
        project: "NothingButNet",
    },
    {
        name: "Nishaad Sovani",
        image: nishaad,
        project: "NeoQuest",
    },
    {
        name: "Siddharth Garimella",
        image: placeholder,
        project: "NeoQuest",
    },
    {
        name: "Arnav Sharma",
        image: placeholder,
        project: "Sortify",
    },
    {
        name: "Caden Luu",
        image: placeholder,
        project: "Sortify",
    },
    {
        name: "Austin Tenbrink",
        image: placeholder,
        project: "SightLine",
    },
    {
        name: "Chad Park",
        image: chad,
        project: "SightLine",
    },
    {
        name: "Ryan Lin",
        image: ryan,
        project: "SightLine",
    },
    {
        name: "Ashley Iattoni",
        image: ashleyi,
        project: "TCP (Traffic Control Patterns), ChessBlitz",
    },
    {
        name: "Benjamin Huang",
        image: benh,
        project: "TCP (Traffic Control Patterns)",
    },
    {
        name: "Dayton Phan",
        image: placeholder,
        project: "TCP (Traffic Control Patterns)",
    },
    {
        name: "Matthew Rodrigues",
        image: placeholder,
        project: "ChessBlitz",
    },
    {
        name: "Peter Lourenco",
        image: peter,
        project: "ChessBlitz",
    },
    {
        name: "Yashom Kapoor",
        image: yashom,
        project: "ChessBlitz",
    },
    {
        name: "Cindy Wang",
        image: placeholder,
        project: "Atlas",
    },
    {
        name: "Ojasvi Shrivastava",
        image: placeholder,
        project: "Atlas",
    },
    {
        name: "Chester Duan",
        image: placeholder,
        project: "Atlas",
    },
    {
        name: "Avaneesh Joshi",
        image: placeholder,
        project: "Atlas",
    },
    {
        name: "Benjamin Wang",
        image: placeholder,
        project: "Mechanistic Transfer During Fine-Tuning",
    },
    {
        name: "Haaziq Kazi",
        image: placeholder,
        project: "Mechanistic Transfer During Fine-Tuning",
    },
    {
        name: "Leo Park",
        image: leo,
        project: "Mechanistic Transfer During Fine-Tuning",
    },
    {
        name: "Arnav Mahadev",
        image: arnav,
        project: "Nexus",
    },
    {
        name: "Ganesh Karayi",
        image: ganesh,
        project: "Nexus",
    },
    {
        name: "Felicia Ye",
        image: felicia,
        project: "Village Hub",
    },
    {
        name: "Helena Zhang",
        image: helena,
        project: "Village Hub",
    },
    {
        name: "Emmanuel Elizalde-Ocampo",
        image: placeholder,
        project: "Village Hub",
    },
    {
        name: "Justin Le",
        image: justin,
        project: "Smpler",
    },
    {
        name: "Sainik Ghosh",
        image: sainik,
        project: "Smpler",
    },
    {
        name: "Christopher Chang",
        image: chris,
        project: "Cabal",
    },
    {
        name: "Karthik Subramanian",
        image: karthik,
        project: "Cabal",
    },
    {
        name: "Jason Shorey",
        image: placeholder,
        project: "DevPad",
    },
    {
        name: "Yuchan Chang",
        image: placeholder,
        project: "DevPad",
    },
];

export const alumni = [
    {
        name: "Ethan Ikegami",
        link: "https://ethanikegami.com/",
        title: "Co-Founder",
        image: ethan,
    },
    {
        name: "Nick Litvinov",
        link: "https://www.linkedin.com/in/nick-litvinov-ab04981b5/",
        title: "Co-Founder",
        image: nick,
    },
    {
        name: "Colin FitzGerald",
        link: "https://www.linkedin.com/in/colinfitzgerald328/",
        title: "Co-Founder",
        image: colin,
    },
    {
        name: "Uyen Phan",
        link: "https://uyentphan.com/",
        title: "Co-Founder",
        image: uyen,
    },
    {
        name: "Nhu Vu",
        link: "https://www.linkedin.com/in/nhu-vu-0b9b89215/",
        title: "Co-Founder",
        image: nhu,
    },
    {
        name: "Joel Jaison",
        link: "https://www.linkedin.com/in/joel-jaison/",
        title: "Co-Founder",
        image: joel,
    },
    {
        name: "Jessica Lee",
        link: "https://www.linkedin.com/in/jessica-lee-5370b71b4",
        title: "",
        image: jess,
    },
    {
        name: "Christopher Bannon",
        link: "https://cbannon.com/",
        title: "",
        image: christopher,
    },
    {
        name: "Kitty Ng",
        link: "https://www.linkedin.com/in/kitty-ng-443678246/",
        title: "",
        image: kitty,
    },
    {
        name: "Rohan Agarwal",
        link: "https://www.linkedin.com/in/rohan-agarwal-2908321a1",
        title: "",
        image: rohan,
    },
    {
        name: "Zee Babar",
        link: "https://www.linkedin.com/in/moebabar",
        title: "",
        image: zee,
    },
];